const stepMap = {
  Create_New_Book: 1,
  Upload_Your_Cover_Photo: 2,
  Upload_Images: 3,
  Design_Your_Cover_Page: 4,
  Review_Your_Book: 5,
};

const getActiveStep = () => {
  const params = new URLSearchParams(window.location.search);
  const stepCode = params.get('stepCode');

  return stepMap[stepCode] || 5;
};

// Mark a step as visited in localStorage
const markStepAsVisited = (stepCode, activeBookId) => {
  if (!activeBookId) return;

  const stepNumber = stepMap[stepCode];
  if (!stepNumber) return;

  const storageKey = `visitedSteps_${activeBookId}`;
  const stored = localStorage.getItem(storageKey);
  const visited = stored ? JSON.parse(stored) : [];

  if (!visited.includes(stepNumber)) {
    visited.push(stepNumber);
    localStorage.setItem(storageKey, JSON.stringify(visited));
  }
};

// Get all visited steps for a book
const getVisitedSteps = (activeBookId) => {
  if (!activeBookId) return [];
  
  const storageKey = `visitedSteps_${activeBookId}`;
  const stored = localStorage.getItem(storageKey);
  return stored ? JSON.parse(stored) : [];
};

// Clear visited steps for a book (useful when book is deleted/completed)
const clearVisitedSteps = (activeBookId) => {
  if (!activeBookId) return;
  
  const storageKey = `visitedSteps_${activeBookId}`;
  localStorage.removeItem(storageKey);
};

function createSlug(text, options = {}) {
  const {
    separator = '-',
    lowercase = true,
    strict = false
  } = options;

  if (!text) return '';

  let slug = text.toString();

  // Convert to lowercase if specified
  if (lowercase) {
    slug = slug.toLowerCase();
  }

  // Normalize unicode characters (handles accents, diacritics, etc.)
  slug = slug.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // Replace common special characters with their equivalents
  const specialChars = {
    '&': 'and',
    '@': 'at',
    '%': 'percent',
    '+': 'plus',
    '=': 'equals',
    '<': 'less-than',
    '>': 'greater-than',
    '|': 'or',
    '\\': 'slash',
    '/': 'slash',
    '#': 'hash'
  };

  if (!strict) {
    Object.keys(specialChars).forEach(char => {
      slug = slug.replace(new RegExp('\\' + char, 'g'), ` ${specialChars[char]} `);
    });
  }

  // Remove all non-word characters (except spaces and separator)
  slug = slug.replace(/[^\w\s-]/g, '');

  // Replace multiple spaces or separators with single separator
  slug = slug.replace(/[\s_-]+/g, separator);

  // Remove leading and trailing separators
  slug = slug.replace(new RegExp(`^${separator}+|${separator}+$`, 'g'), '');

  return slug;
}

export { getActiveStep, markStepAsVisited, getVisitedSteps, clearVisitedSteps, createSlug };